"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FooterRow;

var React = _interopRequireWildcard(require("react"));

function FooterRow(props) {
  return /*#__PURE__*/React.createElement("tr", props);
}